import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {UrlsResources} from "../urls-resources";
import {HandleError} from '../handle-error';
import * as moment from "moment";
import {Observable} from "rxjs/Observable";
import {GanalottodoUsersDashboardBean} from "./glotto-users-dashboard.model";
import {ActivedPromotions} from "../promociones/actived-promotions";
import {Environment} from "../environment-core";
import {GlottoCustomer} from "./glotto-customer";

@Injectable()
export class UsersService {

  private options = {
    headers: new HttpHeaders().set('Content-Type', 'application/json; charset=UTF-8')
  };

  constructor(private http: HttpClient,
              private handleError: HandleError,
              private urlsResources: UrlsResources,
              private environment: Environment,
  ) {
  }

  getGanalottodoUsersDashboard(rangeDates: Date[]): Observable<any> {

    let methodParams: HttpParams =
      new HttpParams()
        .set('fechaInicial', moment(rangeDates[0]).format("YYYY-MM-DD"))
        .set('fechaFinal', moment(rangeDates[1]).format("YYYY-MM-DD"));

    const httpOptions = {
      params: methodParams,
      withCredentials: true
    };

    return this.http.get<GanalottodoUsersDashboardBean>(this.urlsResources.getGanalottodoUsersDashboard(), httpOptions)
      .map(response => {
        return response;
      }).catch(error => {
        return this.handleError.handleErrorAsObservable(error);
      });

  }

  lookUpUsers(param: { startDate: string; endDate: string; criterios: any[]; moneyType: string }) {

    let methodParams: HttpParams = new HttpParams();
    if (param.startDate) {
      methodParams = methodParams.set('beginDate', moment(param.startDate, "DD-MM-YYYY").format("YYYY-MM-DD"));
    }
    if (param.endDate) {
      methodParams = methodParams.set('endDate', moment(param.endDate, "DD-MM-YYYY").format("YYYY-MM-DD") + "T23:59:59");
    }
    param.criterios.forEach((c) => {
      methodParams = methodParams.append("criterias", c);
    });

    if (param.moneyType) {
      methodParams = methodParams.append("moneyType", param.moneyType);
    }

    const httpOptions = {
      params: methodParams,
      withCredentials: true
    };

    console.log("lookUpUsers:httpOptions");
    console.log(httpOptions);

    return this.http.get<GanalottodoUsersDashboardBean>(this.urlsResources.countUsersByCriterias(), httpOptions)
      .map(response => {
        return response;
      }).catch(error => {
        return this.handleError.handleErrorAsObservable(error);
      });
  }

  enrollCustomerToPromotion(param: { startDate: string; endDate: string; criterios: any[]; promotionKey: string; moneyType: string; }) {

    let methodParams: HttpParams = new HttpParams();
    if (param.startDate) {
      methodParams = methodParams.set('beginDate', moment(param.startDate, "DD-MM-YYYY").format("YYYY-MM-DD"));
    }
    if (param.endDate) {
      methodParams = methodParams.set('endDate', moment(param.endDate, "DD-MM-YYYY").format("YYYY-MM-DD") + "T23:59:59");
    }
    param.criterios.forEach((c) => {
      methodParams = methodParams.append("criterias", c);
    });
    if (param.moneyType) {
      methodParams = methodParams.append("moneyType", param.moneyType);
    }

    methodParams = methodParams.append("promotionKey", param.promotionKey);

    const httpOptions = {
      params: methodParams,
      withCredentials: true
    };

    return this.http.post(this.urlsResources.enrollCustomersByCriterias(), {}, httpOptions)
      .map(response => {
        return response;
      }).catch(error => {
        return this.handleError.handleErrorAsObservable(error);
      });
  }

  getActivedPromotions(): Observable<Array<ActivedPromotions>> {
    const httpOptions = {
      withCredentials: true
    };

    return this.http.get<Array<ActivedPromotions>>(this.urlsResources.activedPromotionsUrl(), httpOptions);
  }


  advanceUsersDownloadCsv(param: { startDate: string; endDate: string; criterios: any[], moneyType: string }): Observable<Blob> {
    let methodParams: HttpParams = new HttpParams();
    if (param.startDate) {
      methodParams = methodParams.set('beginDate', moment(param.startDate, "DD-MM-YYYY").format("YYYY-MM-DD"));
    }
    if (param.endDate) {
      methodParams = methodParams.set('endDate', moment(param.endDate, "DD-MM-YYYY").format("YYYY-MM-DD") + "T23:59:59");
    }
    param.criterios.forEach((c) => {
      methodParams = methodParams.append("criterias", c);
    });
    if (param.moneyType) {
      methodParams = methodParams.append("moneyType", param.moneyType);
    }

    let message = `${this.urlsResources.advanceUsersDownloadCsv()}?${methodParams.toString()}`;
    console.log(message);
    return this.http.get(message, {
      withCredentials: true,
      responseType: "blob"
    });
  }

  getGanalottodoCustomers(httpParams): Observable<Array<GlottoCustomer>> {
    const httpOptions = {
      withCredentials: true,
      params: httpParams,
    };

    return this.http.get<Array<GlottoCustomer>>(this.urlsResources.glottoCustomersUrl(), httpOptions);
  }

  getGanalottodoCustomer(httpParamas): Observable<GlottoCustomer> {
    const httpOptions = {
      withCredentials: true,
      params: httpParamas
    };
    return this.http.get(this.urlsResources.glottoCustomerUrl(), httpOptions);
  }

  updateUser(userData): Observable<any> {
    const httpOptions = {
      withCredentials: true,
    };
    return this.http.patch(this.urlsResources.glottoRiskPreventionUpdateCustomerUrl(), userData, httpOptions);
  }

  getGanalottodoCustomerTransactions(username: string, limit: number = 10): Observable<any> {
    const params = new HttpParams()
      .set('username', username)
      .set('limit', limit.toString());
    const httpOptions = {
      withCredentials: true,
      params
    };
    return this.http.get(this.urlsResources.glottoCustomerTransactionsUrl(), httpOptions)
      .catch(error => this.handleError.handleErrorAsObservable(error));
  }

  deleteCustomer(username: string, reason: string): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders().set('Content-Type', 'application/json; charset=UTF-8'),
      withCredentials: true
    };
    return this.http.post(this.urlsResources.deleteCustomerUrl(username), { reason }, httpOptions)
      .catch(error => this.handleError.handleErrorAsObservable(error));
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/core/customers/glotto-users.service.ts